"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * @param {string[]} wordIds
 */
class WordsNotFoundError extends client_library_1.ExtendableError {
    constructor(wordIds) {
        super(`One or more words could not be found. Requested wordIds: ${wordIds.join(', ')}`);
        this.wordIds = wordIds;
    }
}
exports.default = WordsNotFoundError;
//# sourceMappingURL=WordsNotFoundError.js.map